import BaseModel from '../BaseModel';
import Interviewer from './Interviewer';
import Vacancy from '../Vacancy/Vacancy';

export default class VacancyScript extends BaseModel {
  static entity = 'vacancyScripts';

  static primaryKey = 'id';

  static fields() {
    return {
      id: this.attr(null),
      vacancyId: this.attr(null),
      vacancy: this.belongsTo(Vacancy, 'id'),
      interviewerId: this.attr(null),
      interviewer: this.belongsTo(Interviewer, 'interviewerId'),
      questions: this.attr([]),
    };
  }

  static apiConfig = {
    actions: {
      store(vacancyId, payload) {
        return this.post(`vacancies/${vacancyId}/script`, payload);
      },
    },
  }
}
